import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>Seth Mr. Sanwariya<br />Agro Primes</h3>
            <p>
              A new-generation Indian merchant exporter delivering premium frozen foods,
              organic spices, foxnuts, and dehydrated vegetable powders to global markets.
              IEC & FSSAI Certified.
            </p>
            <div className="social-links">
              <a
                href="https://www.linkedin.com/in/sujal-gupta-exports"
                target="_blank"
                rel="noreferrer"
                className="social-link"
                title="LinkedIn"
              >
                in
              </a>
              <a
                href="https://wa.me/919528480615"
                target="_blank"
                rel="noreferrer"
                className="social-link"
                title="WhatsApp"
              >
                💬
              </a>
              <a
                href="mailto:info@sanwariyaagroglobal.com"
                className="social-link"
                title="Email"
              >
                ✉
              </a>
            </div>
          </div>

          <div>
            <div className="footer-heading">Quick Links</div>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/quality">Quality & Certifications</Link></li>
              <li><Link to="/export-process">Export Process</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="footer-heading">Products</div>
            <ul className="footer-links">
              <li><Link to="/products?cat=frozen">Frozen Foods</Link></li>
              <li><Link to="/products?cat=spices">Organic Spices</Link></li>
              <li><Link to="/products?cat=foxnuts">Foxnuts (Makhana)</Link></li>
              <li><Link to="/products?cat=dehydrated">Dehydrated Powders</Link></li>
            </ul>

            <div className="footer-heading" style={{ marginTop: '24px' }}>Contact</div>
            <ul className="footer-links">
              <li>
                <a href="tel:+919528480615">+91 95284 80615</a>
              </li>
              <li>
                <a href="mailto:info@sanwariyaagroglobal.com">info@sanwariyaagroglobal.com</a>
              </li>
              <li>
                <a href="mailto:contact@sanwariyaagroglobal.com">contact@sanwariyaagroglobal.com</a>
              </li>
              <li>Kasganj, Uttar Pradesh, India</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2024–2026 Seth Mr. Sanwariya Agro Primes. All rights reserved. |
            IEC: Granted 11/05/2026 | FSSAI & APEDA Certified
          </p>
          <p>Designed for global trade excellence</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
